import { lowerCase, startCase } from 'lodash';

export default function toCapitalized(string) {
  return startCase(lowerCase(string));
}
